import React from 'react';
import {
  Card,
  CardTitle,
  Button,
  CardBody,
  Typography,
} from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
const { objectOf, shape } = proptypes;
import { formatPhoneNumber } from '../../utils/helpers';
import { Address } from '../Address';
import { ADDRESSES_PATH } from '../../constants/links';

export const AddressDataCard = ({ address }) => {
  const {
    name: { firstName, lastName, nickName },
    postalDetails: {
      addressLine1, addressLine2, city, state, zipCode
    },
    companyName,
    phones,
  } = address;

  const checkPhoneNumber = (customerPhones) => {
    if (Array.isArray(customerPhones) && customerPhones.length) {
      const primaryPhone = customerPhones.find((phone) => phone.primaryFlag === 'Y');
      if (primaryPhone) {
        return formatPhoneNumber(primaryPhone.number);
      }
    }
    return undefined;
  };

  const onViewAllClick = () => {
    window.LIFE_CYCLE_EVENT_BUS.trigger('shipping-address-card-view-all.click');
  };

  const formatedPhoneNumber = checkPhoneNumber(phones);

  return (
    <Card grow PaperProps={{ className: 'sui-flex sui-h-full' }} data-component="ShippingAddressCardAddressDataCard">
      <CardTitle
        header={(
          <Typography height="tight" variant="h3" weight="bold">
            Addresses
          </Typography>
        )}
        disableActionSpacing
        action={(
          <Button variant="text" href={ADDRESSES_PATH} onClick={onViewAllClick}>
            View All
          </Button>
        )}
        subheader={(
          <Typography variant="body-lg" color="subtle">
            Default Address
          </Typography>
        )}
      />
      <CardBody>
        {(firstName || lastName) && (
          <Typography variant="h4">
            {firstName} {lastName}
          </Typography>
        )}
        {nickName && (
          <Typography variant="body-lg" color="subtle">
            {nickName}
          </Typography>
        )}
        <Address
          companyName={companyName}
          addressLine1={addressLine1}
          addressLine2={addressLine2}
          city={city}
          state={state}
          zipCode={zipCode}
          formatedPhoneNumber={formatedPhoneNumber}
        />
      </CardBody>
    </Card>
  );
};

AddressDataCard.displayName = 'AddressDataCard';

AddressDataCard.propTypes = {
  address: objectOf(shape)
};

AddressDataCard.defaultProps = {
  address: {}
};